import api from '@api/api';
import { LandingPage } from '@customTypes/Entities';
import useFetchAll from '@hooks/useFetchAll';

const useLandingPages = (date?: string) => {
  const { data, isFetching, error, ...rest } = useFetchAll<LandingPage>({
    queryKeyRoot: 'landing-pages',
    apiFn: (params) => api.getLandingPages(params),
    date,
  });

  return { landingPages: data, isFetching, error, ...rest };
};

export default useLandingPages;
